module.exports = __webpack_public_path__ + "static/img/24-红英小学(韩家川校区)1.64c6660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/24-红英小学(韩家川校区)1.png
// module id = jtBN
// module chunks = 0